import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import api from '@/store/api/invoice'
// Modules
import invoice from './invoice'

const initialState = () => ({
    invoices: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        invoices: state => state.invoices.data,
        pagination: state => state.invoices.pagination
    },
    actions: {
        /**
         * @param {{}} params
         * @returns {Promise<*>}
         */
        listInvoices: async ({commit, dispatch}, params) => {
            try {
                const response = await api.listInvoices(params)
                const invoices = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }
                commit(mutationTypes.SET_INVOICES, invoices)
                return invoices
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetInvoices: ({commit}) => commit(mutationTypes.RESET_INVOICES)
    },
    modules: {
        invoice
    },
    mutations: {
        [mutationTypes.RESET_INVOICES]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_INVOICES]: (state, data) => state.invoices = data
    }
}
